import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Grid } from "@/components/Grid";
import { Heading } from "@/components/Heading";

import { Item } from "./Item";
import { IExtractImagesFromXDHowItWorksSection } from "./types";

type IProps = IExtractImagesFromXDHowItWorksSection;

export const ExtractImagesFromXDHowItWorksSection: React.FC<IProps> = ({
  title,
  description,
  items,
}) => {
  const { bp, colors } = useTheme();
  const { css } = useFela();

  return (
    <Grid
      customStyle={{
        padding: "40px 20px",
        display: "flex",
        flexDirection: "column",
        [bp.FROM_DESKTOP]: {
          padding: "120px 20px",
        },
      }}
      wrapperStyle={{ backgroundColor: colors.GHOST_WHITE, overflow: "hidden" }}
    >
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        })}
      >
        <Heading
          as="h3"
          customStyle={{
            fontSize: 36,
            lineHeight: "48px",
            marginBottom: 18,
            letterSpacing: "-0.02rem",
            color: colors.DARK_GREY,
            fontWeight: 700,
            textAlign: "center",
            [bp.FROM_DESKTOP]: {
              maxWidth: 600,
              fontSize: 48,
              lineHeight: "60px",
              marginBottom: 16,
            },
          }}
        >
          {title}
        </Heading>
        <p
          className={css({
            textAlign: "center",
            fontSize: 16,
            marginBottom: 64,
            lineHeight: "24px",
            color: colors.DARK_GREY,
            [bp.FROM_TABLET]: {
              maxWidth: 470,
              marginBottom: 80,
            },
          })}
        >
          {description}
        </p>
      </div>

      <div
        className={css({
          display: "grid",
          gridTemplateColumns: "1fr",
          gap: "40px 0",
          [bp.FROM_TABLET]: {
            gridTemplateColumns: "1fr 1fr",
            gridAutoFlow: "dense",
            gap: "160px 96px",
          },
        })}
      >
        {items.map(
          ({
            title,
            description,
            image,
            icon,
            iconColor,
            rightSidedImage,
            button,
          }) => (
            <Item
              key={`extract_image_from_xd_how_it_works_item_${title.replace(
                " ",
                "_",
              )}`}
              title={title}
              description={description}
              image={image}
              icon={icon}
              iconColor={iconColor}
              rightSidedImage={rightSidedImage}
              button={button}
            />
          ),
        )}
      </div>
    </Grid>
  );
};
